import { getData } from '@/utils/axiosUtils';

const getWebexLoginLink = async (
    companyId,
    location = window.location.href,
) => {
    return await getData(
        `/company/${companyId}/WebexLoginLink?domain=${location}`,
    );
};

export default getWebexLoginLink;
